/**
 * Pedidos que la caja rechazó (anulados) y que el mesero todavía no ha visto. «Visto» se recuerda en este
 * equipo: el mesero toca «Entendido» en su lista de pedidos pendientes y deja de avisarse.
 */
const CLAVE = "pedidos_rechazados_vistos";

export function idsVistos() {
  try {
    return JSON.parse(localStorage.getItem(CLAVE) || "[]");
  } catch (e) {
    return [];
  }
}

export function marcarVisto(id) {
  try {
    const vistos = idsVistos();
    if (!vistos.includes(id)) {
      vistos.push(id);
      localStorage.setItem(CLAVE, JSON.stringify(vistos.slice(-100)));
    }
  } catch (e) {
    // sin almacenamiento el aviso vuelve a salir; no es grave
  }
}

export function esRechazado(pedido) {
  return !!pedido && pedido.order_status === "annulled";
}

// La caja lo devolvió para corregirlo: sigue abierto y el mesero debe actuar hasta que lo reenvíe.
export function esDevuelto(pedido) {
  return !!pedido && pedido.order_status === "returned";
}

function rastroDe(pedido) {
  let rastro = pedido && pedido.data_order_trace;
  if (typeof rastro === "string") {
    try {
      rastro = JSON.parse(rastro);
    } catch (e) {
      rastro = [];
    }
  }
  return rastro || [];
}

function ultimaDevolucion(pedido) {
  const entradas = rastroDe(pedido).filter((e) => e && e.status === "returned");
  return entradas[entradas.length - 1] || null;
}

// Por qué cocina o la caja marcó «No se puede» la línea que está en esa posición del pedido.
export function razonImposible(pedido, indice) {
  const entradas = rastroDe(pedido).filter(
    (e) => e && e.status === "line_unavailable" && (e.lines || []).some((l) => l.index === indice)
  );
  const ultima = entradas[entradas.length - 1];
  return (ultima && ultima.reason) || "";
}

export function motivoDevolucion(pedido) {
  const ultima = ultimaDevolucion(pedido);
  return (ultima && ultima.reason) || "";
}

// Los productos que la caja marcó al devolver: [{ index, name }]. Vacío si devolvió el pedido completo.
export function lineasDevueltas(pedido) {
  const ultima = ultimaDevolucion(pedido);
  return (ultima && ultima.lines) || [];
}

// Productos que cocina o la caja marcaron «No se puede» y el mesero aún no quitó del pedido: [{ name, reason }].
export function lineasImposibles(pedido) {
  let lineas = pedido && pedido.data_items;
  if (typeof lineas === "string") {
    try {
      lineas = JSON.parse(lineas);
    } catch (e) {
      lineas = [];
    }
  }
  return (lineas || [])
    .map((l, i) => ({ l, i }))
    .filter(({ l }) => l && l.status === "unavailable")
    .map(({ l, i }) => ({ name: (l.product && l.product.name) || "Producto", reason: razonImposible(pedido, i) }));
}

export function requiereAtencion(pedido) {
  return esDevuelto(pedido) || sinVer(pedido) || lineasImposibles(pedido).length > 0;
}

export function sinVer(pedido) {
  return esRechazado(pedido) && !idsVistos().includes(pedido.id);
}
